import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { TranslateModule } from "@ngx-translate/core";
import { ACCUEIL, CONNEXION } from "@shared/constants/route.constants";
import { MembersService } from "@shared/services/members.service";
import { Brands, isPartner } from "@shared/utils/brand-utils";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-popup-events-payment",
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, DialogModule, TranslateModule],
  templateUrl: "./popup-events-payment.component.html",
  styleUrl: "./popup-events-payment.component.scss",
})
export class PopupEventsPaymentComponent {
  @Input() paymentSuccess!: boolean;
  @Input() showPopupPayment!: boolean;
  @Input() hasToken!: boolean;
  @Input() userEmail!: string;
  @Input() firstConnectionUrl = "";
  @Input() advancePayment = false;
  @Input() unpaidPolicy = false;
  @Output() dialogEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly router: Router,
    private readonly membersService: MembersService
  ) {}

  close(): void {
    if (!this.paymentSuccess) {
      this.dialogEmitter.emit(false);
    } else if (this.hasToken) {
      this.router.navigate([ACCUEIL]);
    } else {
      if(isPartner(environment))
      {
        this.redirectToBrandSubscriberSpace();
        return;
      }

      this.membersService.isEnrolled(this.userEmail).subscribe(status => {
        if (status) {
          this.router.navigate([CONNEXION]);
        } else {
          this.router.navigateByUrl(this.firstConnectionUrl);
        }
      });
    }
  }


  private redirectToBrandSubscriberSpace(): void {
    switch (environment.brand) {
        case Brands.HM:
          window.location.href = environment.EspaceAdherentUrl.HM;
          break;
        case Brands.MGEN:
          window.location.href = environment.EspaceAdherentUrl.MGEN;
          break;
        case Brands.MNT:
          window.location.href = environment.EspaceAdherentUrl.MNT;
          break;
        default:
          throw new Error(`Unsupported brand for Partnera Auth: ${environment.brand}`);
      }
  }
}
